import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Legal.scss';

const Refunds = () => {
  return (
    <>
      <Header />
      <div className="legal-container">
        <div className="legal-content">
          <Link to="/" className="back-link">
            <FiArrowLeft size={20} />
            <span>Back to Home</span>
          </Link>

          <h1 className="legal-title">Cancellation and Refunds Policy</h1>
          <p className="legal-updated">
            Last Updated:{" "}
            {new Date().toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>

          <div className="legal-section">
            <h2>1. Overview</h2>
            <p>
              At INVITS, owned and operated by <strong>Forte Technologies</strong>, we strive to provide the best experience for our users. This Cancellation and Refunds Policy outlines the terms under which you may cancel services or request refunds.
            </p>
            <p>
              By using our Service and making any purchases, you agree to this policy. Please read it carefully before making any transactions.
            </p>
            <p>
              <strong>Note:</strong> The <strong>INVITS platform fee is strictly non-refundable</strong> under all circumstances, except in cases where a transaction fails due to a verified platform error.
            </p>
          </div>

          <div className="legal-section">
            <h2>2. Event Tickets and Registrations</h2>

            <h3>2.1 Organizer Refund Policy</h3>
            <p>
              Organizers creating invitations with paid passes are responsible for specifying their refund policy. Users purchasing passes must comply with the organizer's refund terms.
            </p>
            <p>
              INVITS is not liable for refunds. Users must contact the event organizer or host directly for any refund requests.
            </p>

            <h3>2.2 Refund Requests</h3>
            <ul>
              <li>Check the event page for the organizer's refund policy.</li>
              <li>Contact the organizer/host directly through the platform if eligible.</li>
              <li>Provide order number, event details, and reason for refund.</li>
            </ul>

            <h3>2.3 Platform Fees</h3>
            <p>
              Platform fees charged by INVITS are for providing access to our digital infrastructure, tools, and payment processing services. These fees are applied per transaction.
            </p>
            <p>
              <strong>Platform fees charged by INVITS are non-refundable under any circumstances.</strong> This includes event cancellations, organizer disputes, or user-requested refunds, unless the refund is due to a <strong>proven platform error or duplicate charge</strong>.
            </p>
            <p>
              Users acknowledge and agree to this condition at the time of payment.
            </p>
          </div>

          <div className="legal-section">
            <h2>3. Unauthorized Transactions and Fraud</h2>
            <p>
              If INVITS detects fraud, suspicious activity, or policy violations, we reserve the right to:
            </p>
            <ul>
              <li>Terminate the user or organizer account immediately.</li>
              <li>Pursue legal action if necessary.</li>
              <li>Freeze funds related to fraudulent activity.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>4. Community Membership Fees</h2>
            <p>
              Users can create communities and charge membership fees to other users. INVITS charges a platform commission on all membership fees. By creating a community, you agree to this commission.
            </p>
            <p>
              <strong>The INVITS platform commission and service fees are non-refundable.</strong>
            </p>
          </div>

          <div className="legal-section">
            <h2>5. Changes to This Policy</h2>
            <p>
              We reserve the right to modify this Cancellation and Refunds Policy at any time. Changes will be effective immediately upon posting on our website. Your continued use of the Service after changes are posted constitutes acceptance of the modified policy.
            </p>
          </div>

          <div className="legal-section">
            <h2>6. Contact Information</h2>
            <p>
              For questions about cancellations or refunds, please contact us:
            </p>
            <p>
              <strong>Support Email:</strong> support@invits.co
            </p>
          </div>

          <div className="legal-section">
            <h2>7. Important Disclaimer</h2>
            <p>
              <strong>
                The INVITS platform fee and service commissions are strictly non-refundable.
              </strong>{" "}
              By completing a payment on INVITS, you acknowledge and accept this condition.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Refunds;
